import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const Trash = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            width={props.size}
            height={props.size}>
            <path fillRule="evenodd" clipRule="evenodd"
                d="M15 6C14.4477 6 14 6.44772 14 7V9L26 9V7C26 6.44772 25.5523 6 25 6L15 6ZM28 9V7C28 5.34315 26.6569 4 25 4L15 4C13.3431 4 12 5.34314 12 7L12 9H6C5.44772 9 5 9.44771 5 10C5 10.5523 5.44772 11 6 11H9V33C9 34.6569 10.3431 36 12 36H28C29.6569 36 31 34.6569 31 33V11H34C34.5523 11 35 10.5523 35 10C35 9.44771 34.5523 9 34 9H28ZM11 11V33C11 33.5523 11.4477 34 12 34H28C28.5523 34 29 33.5523 29 33V11H11ZM15 29V16C15 15.4477 15.4477 15 16 15C16.5523 15 17 15.4477 17 16V29C17 29.5523 16.5523 30 16 30C15.4477 30 15 29.5523 15 29ZM24 15C24.5523 15 25 15.4477 25 16V29C25 29.5523 24.5523 30 24 30C23.4477 30 23 29.5523 23 29V16C23 15.4477 23.4477 15 24 15Z"
                fill={props.color ? props.color : "white"} />
        </SvgStyled>
    );
};

export default Trash;
